import mainCaller from "./mainCaller";

export async function getEmployeePositionsList(token, query) {
  return await mainCaller(`admin/api/v1/employeePosition/selectList?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createEmployeePosition(data) {
  return await mainCaller(`admin/api/v1/employeePosition/insert`, "POST", data, {
    "Content-type": "multipart/form-data",
  });
}

export async function updateEmployeePosition(data) {
  return await mainCaller(`admin/api/v1/employeePosition/update`, "PUT", data, {
    "Content-type": "multipart/form-data",
  });
}


export async function deleteEmployeePosition(data, token) {
  return await mainCaller(`admin/api/v1/employeePosition/delete`, "DELETE", data, {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  });
}

export async function getPositionEmployeeCount(token, selectedId) {
  return await mainCaller(`admin/api/v1/employeePosition/employee-count?selectedId=${selectedId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}